import { FunctionComponent } from "react";
import { StyledButton } from "./button.styles";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import Icon from "./icon";

interface ButtonProps {
  children: any;
  className?: string;
  disabled?: boolean;
  onClick: () => void;
  icon?: IconProp;
  iconPosition?: string;
  id?: string;
  style?: any;
  type?: "button" | "submit" | "reset";
}

const Button: FunctionComponent<ButtonProps> = ({
  children,
  id,
  onClick,
  disabled = false,
  icon,
  iconPosition,
  className,
  style,
  type = "button",
}) => {
  const renderIcon = () => {
    if (!icon) {
      return null;
    }

    const style =
      iconPosition === "left" ? { paddingRight: 10 } : { paddingLeft: 10 };

    return (
      <div style={style}>
        <Icon icon={icon} size="lg" />
      </div>
    );
  };

  return (
    <StyledButton
      type={type}
      style={style}
      className={className}
      disabled={disabled}
      onClick={onClick}
      id={id}
    >
      {iconPosition === "left" ? renderIcon() : null}
      {children}
      {iconPosition === "right" ? renderIcon() : null}
    </StyledButton>
  );
};

export default Button;
